import React, { useEffect } from "react";
import { Box, Grid, Typography, Card, CardMedia, CardContent, Link } from "@mui/material";
import Footer from "./Footer";
import useMediaQuery from "@mui/material/useMediaQuery";



const Manufacturing= () => {
    const isMobile = useMediaQuery("(max-width: 900px)");


    useEffect(() => {
            window.scrollTo(0, 0); // Scroll to top when component loads
          },[]);
    
        const caseStudies = [
            {
              title: "Elevating Production and Quality with Advanced SAP Solutions",
              company: "Greene, Tweed & Co.",
              description:
                "Tech Informatic Solutions helped Greene Tweed transform their production processes by implementing an SAP solution, providing real-time insights into their manufacturing operations. This partnership improved yield, efficiency, and competitiveness, while reducing waste and enhancing customer service.",
              image: "/image/manufacturing1.jpg",
              link: "/manufacturingcs1", // updated
            },
            {
              title: "Revolutionizing Operations with Multi-Agent Hyper Automation Technology",
              company: "Ternium",
              description:
                "We transformed TERNIUM's supply chain with 'MAGENTTA', a multi-agent AI system. Seamlessly integrating real-time process sensing and hyper-interconnected supply chain agents led to significant improvements in operational efficiency and a move towards round-the-clock autonomous management.",
              image: "/image/manufaccs1.jpg",
              //link: "/educationcs2", // updated
            },
          ];

return (
    <>
      {/* First Section - Background Image */}
      <Box
  sx={{
    position: "relative",
    width: "100%",
    minHeight: "100vh", // Use minHeight instead of fixed height
    backgroundImage: `url("/image/manufacimg.jpg")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    color: "white",
    overflow: "hidden", // Prevents content from spilling over
  }}
>
  {/* Dark overlay for readability */}
  <Box
    sx={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    }}
  />

  {/* Content Box */}
  <Box
    sx={{
      position: "relative",
      maxWidth: "700px",
      marginLeft: { xs: "3%", md: "8%" },
      marginTop: { xs: "50%", md: "15%" }, // Reduce margin to avoid overflow
      zIndex: 1,
      padding: 4,
      
    }}
  >
    <Typography 
      variant="h3" 
      sx={{ 
        fontWeight: "bold", 
        mb: 2, 
        fontSize: { xs: "42px", md: "60px" }, // Reduce size slightly for better fit
      }}
    >
    Manufacturing
    </Typography>
    <Typography 
      variant="body1" 
      sx={{ 
        fontSize: { xs: "18px", md: "18px" }, 
        maxWidth: "100%", 
        wordBreak: "break-word", 
        lineHeight: 1.5, 
      }}
    >
  Navigate a dynamic, disrupted global landscape by modernizing and transforming your manufacturing enterprise. </Typography>
  </Box>
</Box>



   
{/* 2nd Section  */}

<Box sx={{ position: "relative", overflow: "hidden" }} >
  {/* Background Half-Moon Shape */}
  <Box
    sx={{
      position: "absolute",
      top: 0,
      right: 0,
      width: isMobile ? "100%" : "70%",
      height: "100%",
      background: "linear-gradient(to right, #E0F7FA, #B2EBF2, #80DEEA)",
      borderTopLeftRadius: isMobile ? "100% 40%" : "100% 100%",
      borderBottomLeftRadius: isMobile ? "100% 40%" : "100% 100%",
      zIndex: 0,
    }}
  />

  {/* Actual Content (your original layout) */}
  <Box
    sx={{
      position: "relative",
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
      justifyContent: "center",
      width: isMobile ? "100%" : "90%",
      padding: isMobile ? "30px 15px" : "50px 50px",
      gap: "50px",
      boxSizing: "border-box",
      margin: "0 auto",
      minHeight: isMobile ? "auto" : "100vh",
      paddingTop: isMobile ? "120px" : "0px",
      marginBottom: isMobile ? "100px" : "-50px",
      zIndex: 1,
    }}
  >
    {/* Left Content */}
    <Box
      sx={{
        flex: 1,
        textAlign: isMobile ? "center" : "left",
        margin: "0px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontSize: isMobile ? "50px" : "60px",
          marginTop: "-10px",
        }}
        mb={8}
      >
     Creating a competitive advantage through industrial innovation
      </Typography>

      <Typography variant="body1" sx={{ marginTop: 2, fontSize: "18px", color: "#333" }}>
      In a competitive and complex modern manufacturing industry, you need a trusted technology partner to drive transformation across the value chain.</Typography>
      <Typography variant="body1" sx={{ marginTop: 2, fontSize: "18px", color: "#333" }}>
      We deliver robust and agile transformation through a leading suite of manufacturing consulting and digital operations services, combined with industry-specific technology solutions.</Typography>


    </Box>

    {/* Right Image */}
    <Box
      sx={{
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "0px",
        marginTop: isMobile ? "50px" : "0px",
      }}
    >
      <img
        src="/image/manufacimg1.jpg"
        alt="About Us"
        style={{
          width: isMobile ? "90%" : "100%",
          maxHeight: "100%",
          objectFit: "cover",
          borderRadius: "10px",
          boxShadow: `
            0px 12px 25px rgba(0, 0, 0, 0.6),  
            inset 0px 10px 20px rgba(255, 255, 255, 0.15),
            inset 0px -10px 30px rgba(0, 0, 0, 0.7),
            inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
            inset -10px 0px 20px rgba(255, 255, 255, 0.2)
          `,
        }}
      />
    </Box>
  </Box>
</Box>









{/* 3rd section */}
<Box sx={{  width: "100%", padding: "40px 0" , background: "radial-gradient(circle, #1F6788,#161623)"}}>
<Box sx={{ px: { xs: 2, md: 10 }, py: 8 }}>
      {/* Title Section */}
      <Typography variant="h3" color="white" fontWeight="bold" gutterBottom  mb={4}>
        Case Studies
      </Typography>
      <Typography variant="body1" sx={{  fontSize: "18px", color: "white" }}  mb={10}>
      Read how companies in the manufacturing industry solved their challenges by partnering with Tech Informatic Solutions.
      </Typography>

      <Grid container spacing={4}>
  {caseStudies.map((item, index) => (
    <Grid item xs={12} md={6} key={index} sx={{ display: "flex" }}>
      <Card
        elevation={0}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
         // background: "radial-gradient(circle, #1F6788,#161623)",
          color: "white",
          border: "1px solid #eee",
          height: "100%",
          width: "100%",
          minHeight: 550, // ✅ Equal height
          boxShadow: `
            0px 12px 25px rgba(0, 0, 0, 0.6),  
            inset 0px 10px 20px rgba(255, 255, 255, 0.15),
            inset 0px -10px 30px rgba(0, 0, 0, 0.7),
            inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
            inset -10px 0px 20px rgba(255, 255, 255, 0.2)
          `,
        }}
      >
        <CardMedia
          component="img"
          height="350"
          image={item.image}
          alt={item.title}
        />

        <CardContent
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography
              variant="caption"
              sx={{ color: "#1976d2", fontWeight: "bold" }}
            >
              {item.company}
            </Typography>

            <Typography
              variant="h6"
              color="black"
              fontWeight="bold"
              mt={1}
            >
              {item.title}
            </Typography>

            <Typography
              variant="body2"
              mt={1}
              color="black"
              sx={{ flexGrow: 1 }}
            >
              {item.description}
            </Typography>
          </Box>

          <Link
            href={item.link}
             target="_blank"
             rel="noopener noreferrer"
             underline="hover"
             sx={{ display: "inline-block", mt: 2, fontWeight: "bold" }}
           >
             Read the case study ↗
           </Link>
          
        </CardContent>
      </Card>
    </Grid>
  ))}
</Grid>

    </Box>
    </Box>



   


<Footer/>
    </>
  );
};
export default Manufacturing;